import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  MenuItem,
  Select,
  ToggleButtonGroup,
  ToggleButton,
  FormControl,
  Autocomplete,
  // TextField,
  ListItemText,
  Skeleton,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import { yellow, red, grey } from "@mui/material/colors";
import { ComponentProps } from "./types";
import { memo, useEffect, useState } from "react";
import moment from "moment";
import { useAppSelector, useAppDispatch } from "../../store/store";
import { getStackRankingDataThunk } from "../../store/thunk/mainDashboardThunk";
import { useNavigate } from "react-router-dom";

const SubstanceFrequency = ({
  id,
  index,
  pin,
  pinComponentHandler,
  selectedValueFacility,
  facilityIds,
  locationIds,
  currentTenant,
  ...rest
}: ComponentProps) => {
  const navigate = useNavigate();
  moment.updateLocale("en", {
    week: { dow: 1 },
  }); /* set monday as first day of week */
  const [filterType, setFilterType] = useState("day");
  const [filterDate, setFilterDate] = useState({
    startDate: moment().startOf("day").utc().valueOf(),
    endDate: moment().utc().valueOf(),
    // endDate: moment().endOf('day').utc().valueOf(),
  });
  const [locationOptions, setLocationOptions] = useState<any>([]);
  const [locationValue, setLocationValue] = useState<any>();
  const locationList = useAppSelector(
    (state) => state?.locationSlice?.locationList?.getLocations || []
  );
  const { userData } = useAppSelector((state) => state.authReducer);
  const stackRanking = useAppSelector(
    (store) => store?.mainDashboard?.stackRanking
  );
  const locationLoader = useAppSelector(
    (store) => store?.locationSlice?.loading
  );
  const tenantLoader = useAppSelector((store) => store?.tenantSlice?.loading);
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    setLoader(stackRanking?.loading || locationLoader || tenantLoader);
  }, [stackRanking?.loading, locationLoader, tenantLoader]);
  const [stackRankingData, setStackRankingData] = useState<
    {
      color: keyof typeof COLORS;
      value: number;
      symbol: string;
      substanceKey: string;
    }[]
  >([]);
  const substanceData = useAppSelector(
    (store) => store?.substanceSlice?.substanceConfigurationList
  );
  useEffect(() => {
    setStackRankingData(() => {
      return stackRanking?.data?.map((value) => {
        // const maxValue = Math.max(parseInt(value?.index1), parseInt(value?.index2), parseInt(value?.index3), parseInt(value?.index4));
        const substanceValue = [
          { color: 1, value: parseInt(value?.index1) },
          { color: 2, value: parseInt(value?.index2) },
          { color: 3, value: parseInt(value?.index3) },
          { color: 4, value: parseInt(value?.index4) },
          { color: 5, value: parseInt(value?.index5) },
        ];
        const maxEntry = substanceValue.reduce((a, b) =>
          a.value > b.value ? a : b
        );
        const substanceDetails = substanceData?.find(
          (sub: any) => value?.pk?.replaceAll("C|", "") === sub?.sk
        );
        const substanceName = (
          substanceDetails?.displayName
            ? substanceDetails?.displayName
            : value?.pk?.replaceAll("C|", "")
        )?.toUpperCase();
        return {
          color: maxEntry?.color as keyof typeof COLORS,
          value: maxEntry?.value,
          symbol: substanceName,
          substanceKey: substanceDetails?.substanceKey,
        };
      });
    });
  }, [JSON.stringify(stackRanking), JSON.stringify(substanceData)]);
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (selectedValueFacility) {
      let rooms: any = [];
      const facilityDetails = locationList.find(
        (value: any) => value.key === selectedValueFacility
      );
      if (facilityDetails?.type === "FU") {
        rooms = locationList?.filter(
          (value: any) =>
            facilityDetails?.key === value?.facility_unit_key &&
            !value?.floor_key &&
            value?.unit_key !== value?.parentKey
        );
        // facilityDetails?.key === value?.facility_unit_key && !value?.floor_key for to find the room that have parentKey of floor not facility group
        // value?.unit_key !== value?.parentKey for to find the room that not belong to unit as well
        console.log("pkkk ", rooms);
        rooms = rooms?.map((value: any) => {
          const floorData = locationList?.find(
            (floor: any) => value?.parentKey === floor?.key
          );
          const facilityData = locationList?.find(
            (facility: any) => facility.key === floorData?.parentKey
          );
          return {
            key: value.key,
            name: `${facilityData ? `${facilityData?.name} > ` : ""}${
              floorData ? `${floorData?.name} > ` : ""
            }${value.name}`,
          };
        });
      } else {
        const floorIds = locationList
          .filter(
            (value: any) =>
              value.parentKey === selectedValueFacility && !value?.is_unit
          )
          .map((value: any) => value?.key);
        rooms = locationList.filter((value: any) =>
          floorIds.includes(value.parentKey)
        );
        rooms = rooms?.map((value: any) => {
          const floorData = locationList?.find(
            (floor: any) => value?.parentKey === floor?.key
          );
          return { key: value.key, name: `${floorData?.name} > ${value.name}` };
        });
      }

      setLocationValue(undefined);
      setLocationOptions(rooms);
    }
  }, [JSON.stringify(locationList), selectedValueFacility]);
  const filterHandler = (value: moment.unitOfTime.StartOf) => {
    const startDate = moment().startOf(value).utc().valueOf();
    const endDate = moment().utc().valueOf();
    // const endDate = moment().endOf(value).utc().valueOf();
    setFilterType(value as string);
    setFilterDate({
      startDate,
      endDate,
    });
  };
  const locationChangedHandler = (
    _: React.SyntheticEvent<Element, Event>,
    value: any
  ) => {
    if (!currentTenant?.tenantId && !userData?.tenantId) return;
    setLocationValue(value);
  };
  useEffect(() => {
    const facilityKey = facilityIds?.replace("all,", "");
    if (
      /* currentTenant?.tenantCode &&  */ facilityKey ||
      locationIds /* || userData?.group === 'admin' */
    ) {
      dispatch(
        getStackRankingDataThunk({
          tenantCode: currentTenant?.tenantCode as string,
          facilityKey: facilityKey,
          locationId: locationIds,
          location: !!locationValue ? locationValue?.key : undefined,
          ...filterDate,
        })
      );
    }
  }, [
    /* currentTenant?.tenantCode, */ facilityIds,
    locationIds,
    filterDate,
    locationValue?.key /*  userData?.group */,
  ]);

  const handleClick = (item: any) => {
    const queryParams = new URLSearchParams({
      range: filterType,
    });
  
    if (selectedValueFacility) {
      queryParams.append("facility", selectedValueFacility);
    }
  
    navigate(`/element-detection/${item.substanceKey}?${queryParams.toString()}`);
  };

  return (
    <Card
      sx={{
        width: "100%",
        borderRadius: "3px !important",
        border: "none",
        backgroundColor: "#fff !important",
        boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.1) !important",
        height: "100%",
        padding: "0px !important",
      }}
    >
      <Box
        onClick={() => pinComponentHandler(id)}
        sx={{
          position: "absolute",
          display: "flex",
          justifyContent: "flex-end",
          top: 14,
          right: 14,
          cursor: "pointer",
          zIndex: 99,
        }}
      >
        {pin ? (
          <img src="./assets/images/pin-filled.png" alt="pin" width={15} />
        ) : (
          <img src="./assets/images/pin-outline.png" alt="pin" width={15} />
        )}
      </Box>
      <CardContent
        sx={{
          maxHeight: 450,
          height: 450,
          overflowY: "auto",
          // border: "1px solid #ddd",
          // borderRadius: "8px",
          padding: 2,
          // boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          backgroundColor: "#fff",
          scrollbarWidth: "thin !important",
          paddingTop: "0px !important",
        }}
      >
        <Box
          sx={{
            pt: 2,
            pb: 1,
            position: "sticky",
            top: 0,
            backgroundColor: "#fff",
          }}
        >
          <Box
            sx={{ display: "flex", gap: 1, marginBottom: 2, flexWrap: "wrap" }}
          >
            <Box className="title" {...(pin ? {} : rest)} sx={{ width: "100%", ":hover": (pin ? {} : { backgroundColor: "#f4f4f4", borderRadius: "10px", cursor: "grab", }) }}>
              <Typography variant="h6" sx={{ pl: 1, fontWeight: 'bolder', ":hover": (pin ? {} : { backgroundColor: "#f4f4f4", borderRadius: "10px", cursor: "grab" }) }} gutterBottom>
              Characteristics Frequency
              </Typography>
            </Box>
            {selectedValueFacility && (
              <Autocomplete
                disablePortal
                value={
                  locationValue
                    ? locationValue
                    : { name: "All Locations", key: undefined }
                }
                fullWidth
                id="location-list"
                onChange={locationChangedHandler}
                getOptionLabel={(option: any) => option.name || ""}
                options={[
                  { name: "All Locations", key: undefined },
                  ...locationOptions,
                ]}
                isOptionEqualToValue={(option, value) =>
                  option?.key === value?.key
                }
                renderInput={(params) => (
                  <TextField {...params} label="Locations" />
                )}
              />
            )}
          </Box>
          <ToggleButtonGroup
            exclusive
            size="small"
            sx={{ display: "flex", gap: 2 }}
          >
            <ToggleButton
              disabled={loader || filterType === "day"}
              value="day"
              className={`filter-button ${
                filterType === "day" && "filter-button-color-black"
              }`}
              onClick={(e, value) => {
                filterHandler(value);
              }}
            >
              Daily
            </ToggleButton>
            <ToggleButton
              disabled={loader || filterType === "week"}
              value="week"
              className={`filter-button ${
                filterType === "week" && "filter-button-color-black"
              }`}
              onClick={(e, value) => {
                filterHandler(value);
              }}
            >
              Weekly
            </ToggleButton>
            <ToggleButton
              disabled={loader || filterType === "month"}
              value="month"
              className={`filter-button ${
                filterType === "month" && "filter-button-color-black"
              }`}
              onClick={(e, value) => {
                filterHandler(value);
              }}
            >
              Monthly
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: { md: "center", sm: "center" },
            gap: 1,
            flexWrap: "wrap",
          }}
        >
          {!loader
            ? stackRankingData
                ?.filter((value) => value?.color !== 1)
                .map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      cursor: "pointer",
                      width: "115px",
                      minHeight: "110px",
                      // Optional: using a gradient background for a modern look.
                      background: `linear-gradient(135deg, ${
                        COLORS[item.color]
                      } 0%, ${COLORS[item.color]}CC 100%)`,
                      border: "1px solid rgba(0, 0, 0, 0.1)",
                      p: 2,
                      m: 1,
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.15)",
                      borderRadius: "12px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      // Smooth transition for hover effects
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      // Hover effect for interactivity
                      "&:hover": {
                        transform: "scale(1.05)",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
                      },
                      // Adjusted base typography
                      fontSize: "0.875rem",
                      fontWeight: "500",
                      color: [4, 5].includes(item.color) ? "#fff" : "#000",
                    }}
                  >
                    <Box onClick={() => handleClick(item)} key={index}>
                      <Typography
                        sx={{
                          fontSize: "1.5rem",
                          fontWeight: "bold",
                          mb: 0.5, // margin bottom for spacing between texts
                        }}
                      >
                        {item.value}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          wordBreak: "break-all",
                          fontSize: "1rem",
                        }}
                      >
                        {item.symbol}
                      </Typography>
                    </Box>
                  </Box>
                ))
            : [...new Array(4)].map((_, index) => {
                return (
                  <Skeleton
                    key={index}
                    variant="rectangular"
                    sx={{
                      width: "115px !important",
                      height: "auto",
                      minHeight: "110px",
                      border: "1px solid rgba(0, 0, 0, 0.1)",
                      p: 1,
                      m: 1,
                      boxShadow: "0px 2.93827px 4.40741px rgba(0, 0, 0, 0.15)",
                      borderRadius: "12px",
                    }}
                  />
                );
              })}
        </Box>
        {!loader && !stackRankingData?.length && (
          <Box
            sx={{
              backgroundColor: "#f9f9f9",
              borderRadius: "8px",
              marginY: 3,
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              display: "flex",
              justifyContent: "center",
              p: 2,
            }}
          >
            No data found.
          </Box>
        )}
        {/* </Box> */}
      </CardContent>
    </Card>
  );
};

export default memo(SubstanceFrequency);
const COLORS = {
  1: "#cdffce",
  2: "#ffef5c",
  3: "#ffef5c",
  4: "#871014",
  5: "#000000",
};
